import { CopyToClipboardButton } from 'framework/ui/clipboard';
import Box from '@mui/material/Box';

interface Props {
  businessKey: string | null | undefined;
}

const ProcessInstanceEntityTitle = ({ businessKey }: Props) => {
  const keyCaption = (
    <Box component="span" sx={{ whiteSpace: 'pre-line' }}>
      {businessKey || 'null (Business Key)'}
    </Box>
  );

  const copyKeyButton = businessKey && (
    <CopyToClipboardButton sx={{ ml: 0.5 }} id="copyBusinessKey" value={businessKey}>
      Copy business key
    </CopyToClipboardButton>
  );

  return (
    <>
      {keyCaption}
      {copyKeyButton}
    </>
  );
};

export default ProcessInstanceEntityTitle;
